import { CalendarEvent } from 'angular-calendar';
import { createAction, props } from '@ngrx/store';
//import { FechasSalida } from 'src/app/models/pelicula.model';

export const cargaFS = createAction(
  '[FECHAS SALIDA] Carga',
  props<{ fechassalida: CalendarEvent[] }>()
);
export const limpiaFS = createAction('[FECHAS SALIDA] Remueve');
